const DefaultRoutes = {
    'USER': '/dashboard',
    'ITADMIN': '/users',
    'SUPERADMIN': '/dashboard',
    // ... other roles and their default routes ...
  };
  
  export default DefaultRoutes;